module.exports = __webpack_public_path__ + "static/icon-pledge-5-a52735981d4a529b6a5f6bc916c140c9.svg";